"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const MenuList_1 = __importDefault(require("@material-ui/core/MenuList"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
exports.default = react_1.default.memo(PopOverMenu);
const useStyles = makeStyles_1.default((theme) => ({
    button: {
        height: theme.avatarSize.sm,
        width: theme.avatarSize.sm
    },
    menu: {
        color: colorManipulator_1.alpha(theme.colors.textColor, 0.8),
        backgroundColor: colorManipulator_1.alpha(theme.colors.sidePanel.backgroundColor, 0.8),
        minWidth: 160
    },
    popper: {
        zIndex: 100
    }
}));
function PopOverMenu(props) {
    const classes = useStyles();
    const [open, setOpen] = react_1.useState(false);
    const anchorRef = react_1.useRef(null);
    let buttonClassName = classes.button;
    if (props.className) {
        buttonClassName += " " + props.className;
    }
    const handleClick = (event) => {
        event.preventDefault();
        setOpen(!open);
    };
    const handleClose = () => {
        setOpen(false);
    };
    function buildMenuItemElement(text, action, disable) {
        return (react_1.default.createElement(MenuItem_1.default, { key: text, disabled: disable, onClick: _ => {
                if (!disable) {
                    action();
                    handleClose();
                }
            } },
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, text)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IconButton_1.default, { onClick: handleClick, buttonRef: anchorRef, className: buttonClassName }, props.icon),
        react_1.default.createElement(Popper_1.default, { open: open, anchorEl: anchorRef.current, placement: props.placement, className: classes.popper },
            react_1.default.createElement(Paper_1.default, null,
                react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClose },
                    react_1.default.createElement(MenuList_1.default, { variant: "menu", className: classes.menu + " pop-over-menu" }, props.menuItems.map(m => buildMenuItemElement(m.text, m.action, m.disable))))))));
}
